import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import Navbar from "../Navbar";
import plutonicSmallName from "../../assets/images/plutonicSmallName.svg";
import plutonicLogo from "../../assets/images/plutonicLogo.svg";
import { AuthContext } from "../../context/AuthContext";

function RegisterSelect() {
  const navigate = useNavigate();
  const {
    currentNickname,
    handleLogout,
    PlutonicuserID,
    currentFormType,
    setCurrentFormType,
  } = useContext(AuthContext);

  const registrationOptions = [
    {
      title: "AI Companion Only",
      description: "Access to AI mental health companion for support and guided check-ins",
      features: ["24/7 AI companion access", "Mood tracking", "Coping tools", "Guided exercises"],
      userType: "client-ai-companion",
      route: "/register/ai-companion",
      buttonColor: "border-purple-400 text-purple-400 hover:bg-purple-400",
    },
    {
      title: "Therapy + AI Companion", 
      description: "Full access to therapy sessions with licensed therapists plus AI companion",
      features: ["Licensed therapist sessions", "AI companion support", "Comprehensive care", "All features included"],
      userType: "client-ai-enabled-therapy",
      route: "/register/ai-enabled-therapy",
      buttonColor: "border-green-400 text-green-400 hover:bg-green-400",
    },
    {
      title: "Therapy Only",
      description: "Access to therapy sessions with licensed therapists (no AI companion)",
      features: ["Licensed therapist sessions", "Professional mental health care", "Traditional therapy approach"],
      userType: "Client",
      route: "/register/therapy-only",
      buttonColor: "border-blue-400 text-blue-400 hover:bg-blue-400",
    },
    {
      title: "Mental Health Professional",
      description: "Registration for licensed therapists and mental health providers",
      features: ["Provide therapy sessions", "Client management tools", "Professional dashboard", "Account review required"],
      userType: "Therapist",
      route: "/register/therapist",
      buttonColor: "border-orange-400 text-orange-400 hover:bg-orange-400",
    },
  ];

  return (
    <div
      className="min-h-screen flex flex-col items-center px-4 py-8"
      style={{
        background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
      }}
    >
      <Navbar
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setCurrentFormType={setCurrentFormType}
        showButtons={false}
        PlutonicuserID={PlutonicuserID}
      />

      <div className="mt-[120px] w-full max-w-4xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-4">Choose Your Plan</h1>
          <p className="text-gray-300 text-lg">Select the mental health support that's right for you</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {registrationOptions.map((option, index) => (
            <div
              key={index}
              className={`relative bg-black/80 rounded-3xl shadow-lg p-6 text-white flex flex-col justify-between`}
            >
              <div className="mb-6">
                <h2 className="text-center text-xl font-bold mb-3">{option.title}</h2>
                <p className="text-gray-300 text-sm mb-4">{option.description}</p>
              </div>

              <div className="mb-6">
                <h3 className="font-semibold mb-3 text-gray-200">Features included:</h3>
                <ul className="space-y-2">
                  {option.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm">
                      <svg className="w-4 h-4 mr-2 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <button
                onClick={() => navigate(option.route)}
                className={`w-full h-[48px] px-4 border font-bold rounded-full transition duration-200 hover:text-white ${option.buttonColor}`}
              >
                SELECT PLAN
              </button>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-gray-400 text-sm mb-4">
            Already have an account?{" "}
            <button
              onClick={() => navigate("/login")}
              className="text-[#22AAEE] hover:underline font-semibold"
            >
              Sign In
            </button>
          </p>
          
          <div className="flex items-center justify-center space-x-2 mt-6">
            <img
              src={plutonicLogo}
              alt="Plutonic Logo"
              className="w-[50px] h-[30px]"
            />
            <img
              src={plutonicSmallName}
              alt="company name"
              className="w-20 h-20"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterSelect;
